export const NAVIGATE_TO_AGREEMENT = "navigateToAgreement";
export const POST_REGISTER_REDIRECT_URL_KEY = "postRegisterRedirectUrl";
export const POST_REGISTER_REDIRECT_URL_COXAPOLKU_VALUE = "coxapolku/redirect";
export const POST_REGISTER_REDIRECT_URL_TAYSPOLKU_VALUE = "tayspolku/redirect";